import { DatePipe } from '@angular/common';
import { Component, inject, OnInit, ChangeDetectionStrategy, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { Entity } from '../../entity/entity';
import { EntityHistory } from '../../model/entity-history';
import { EntityHistoryService } from '../../services/entity-history.service';
import { StringUtils } from '../../utils/string-utils';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-entity-history-dialog',
  imports: [DatePipe, MatButton, MatProgressSpinner],
  templateUrl: './entity-history-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './entity-history-dialog.component.css',
})
export class EntityHistoryDialogComponent implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<EntityHistoryDialogComponent>>(MatDialogRef);
  private readonly service = inject(EntityHistoryService);
  private readonly data = inject(MAT_DIALOG_DATA);
  private readonly entity: Entity;
  readonly entityId: string;
  readonly entityHistory = signal<EntityHistory | undefined>(undefined);
  readonly errorMessage = signal<string | undefined>(undefined);
  readonly isBusy = signal(false);

  constructor() {
    this.entity = this.data.entity;
    this.entityId = this.entity.id.entityId + ';' + this.entity.id.entityRevision;
  }

  ngOnInit(): void {
    this.isBusy.set(true);
    this.initializeData()
      .then(() => this.isBusy.set(false))
      .catch((error: any) => this.handleError(error));
  }

  private async initializeData(): Promise<void> {
    this.entityHistory.set(await firstValueFrom<EntityHistory>(this.service.getEntityHistory(this.entity)));
  }

  private handleError(error: any) {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  close(): void {
    this.dialogRef.close();
  }
}
